import { NgModule } from '@angular/core';

import { LibTranslatePipe } from './pipes/lib-translate.pipe';
import { LibTranslateService } from './services/lib-translate.service';

@NgModule({
  imports: [],
  exports: [LibTranslatePipe],
  declarations: [LibTranslatePipe],
  providers: [],
})
export class LibTranslationUtilsModule {}

export { LibTranslateService };
